<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="container mat-elevation-z8 m-2">
  <table mat-table [dataSource]="dataSource" class="w-100">
    <ng-container matColumnDef="permissions">
      <th mat-header-cell *matHeaderCellDef>
        Permissions
        <button mat-icon-button color="primary" (click)="addRole()" [disabled]="!canEdit" matTooltip="Add New Role">
          <mat-icon class="mdi-24px" fontIcon="mdi-plus-circle"> </mat-icon>
        </button>
        <button mat-icon-button color="primary"
          matTooltip="Roles can be set on Users or, if enabled in your environment, can be matched to Role Names from the token of the Identity Provider in use."
          matTooltipShowDelay="0">
          <mat-icon class="mdi-24px" fontIcon="mdi-information"> </mat-icon>
        </button>
      </th>
      <th mat-header-cell *matHeaderCellDef>All</th>
      <td mat-cell *matCellDef="let permission">
        <button mat-icon-button color="primary" [matTooltip]="permissionMap.get(permission)" [matTooltipShowDelay]="0">
          <mat-icon class="mdi-24px" fontIcon="mdi-information"> </mat-icon>
        </button>
        {{ permission }}
      </td>
    </ng-container>

    @for (role of roles$ | async; track trackById($index, role)) {
    <ng-container [matColumnDef]="role.name">
      <th mat-header-cell *matHeaderCellDef>
        <div class="d-flex">
          <p>{{ role.name }}</p>
          @if (canEdit) {
          @if (!role.immutable) {
          <button mat-icon-button color="primary" (click)="renameRole(role)" title="Rename Role">
            <mat-icon class="mdi-24px" fontIcon="mdi-square-edit-outline"></mat-icon>
          </button>
          }
          @if (!role.immutable) {
          <button mat-icon-button color="primary" (click)="deleteRole(role)" title="Delete Role">
            <mat-icon class="mdi-24px" fontIcon="mdi-trash-can-outline"></mat-icon>
          </button>
          }
          }
        </div>
      </th>
      <td mat-cell *matCellDef="let permission">
        @if (permission == allPermission || !role.allPermissions) {
        <mat-checkbox color="primary" [checked]="hasPermission(permission, role)"
          (change)="setPermission(permission, role, $event)" [disabled]="role.immutable || !canEdit"></mat-checkbox>
        }
      </td>
    </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="displayedColumns$ | async; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns$ | async"></tr>
  </table>
</div>
